
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"action.label":"In Excel-Datei exportieren","dialog.title":"Datenerstellung (Excel)"},"en":{"action.label":"Export to Excel file","dialog.title":"Generating Data (Excel)"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();